// @flow
import { connect } from 'react-redux';

import RencontreGeneralSoon, { type StateProps } from 'components/rencontre/general/RencontreGeneralSoon';

import { selectCompetitionLinkOnRencontre } from 'selectors/selectSettings';

import type { StateType } from 'types/Actions';

const mapStateToProps = (state: StateType): StateProps => ({
  ranking: state.rencontreState.ranking,
  lastRencontres: state.rencontreState.lastRencontres,
  rencontreid: state.rencontreState.rencontre.id,
  rencontre: state.rencontreState.rencontre,
  competitionLink: selectCompetitionLinkOnRencontre(state),
});

export default connect(mapStateToProps)(RencontreGeneralSoon);
